webpackJsonp([66148456367157],{

/***/ 355:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulPage":{"title":"Hitta hit","slug":"hitta-hit","metaDescription":null,"body":{"childMarkdownRemark":{"html":"<p>Aston Villa hotell är centralt beläget mellan Göteborgs botaniska trädgård, Slottsskogen, Sahlgrenska universitetssjukhuset och Linnéstaden. I närheten ligger också Wallenbergssalen som är en av Göteborgs största konferenssalar samt Annedalskliniken.</p>\n<p>Vill du åka kollektivtrafik till Aston Villa hotell är närmaste hållplats Sahlgrenska. På <a href=\"https://www.vasttrafik.se\" title=\"Västtrafik\">www.vasttrafik.se</a> hittar du tider och resväg. Vill du åka taxi, ring Taxi Göteborg 031-650000.</p>","excerpt":"Aston Villa hotell är centralt beläget mellan Göteborgs botaniska trädgård, Slottsskogen, Sahlgrenska universitetssjukhuset och Linnéstaden. I närheten ligger också Wallenbergssalen som är en av Göteborgs största konferenssalar samt Annedalskliniken. Vill du åka kollektivtrafik till Aston Villa hotell är närmaste…"}}}},"pathContext":{"slug":"hitta-hit"}}

/***/ })

});


// WEBPACK FOOTER //
// path---hitta-hit-b198c3656b2839f2c8de.js